import { useAppState } from '@/hooks/useAppState';
import { LOGIN, NAVIGATION, SEARCH, SHORTCUTS } from '@/constants/dialogs';
import { type ShortcutKey } from '@/constants/shortcutKeys';
import { type NavigationKey } from '@/constants/navigationKeys';
import LoginDialog from '@/dialogs/LoginDialog';
import SearchDialog from '@/dialogs/SearchDialog';
import ShortcutsDialog from '@/dialogs/ShortcutsDialog';
import NavigationDialog from '@/dialogs/NavigationDialog';

export type DialogsManagerProps = {
  onSelectShortcut: (shortcut: ShortcutKey) => void;
  onSelectNavigation: (shortcut: NavigationKey) => void;
};

export default function DialogsManager({
  onSelectShortcut,
  onSelectNavigation,
}: DialogsManagerProps) {
  const { activeDialogs, onCloseDialog } = useAppState();

  return (
    <>
      {activeDialogs[SEARCH] && (
        <SearchDialog onClose={() => onCloseDialog(SEARCH)} />
      )}
      {activeDialogs[SHORTCUTS] && (
        <ShortcutsDialog
          onSelect={onSelectShortcut}
          onClose={() => onCloseDialog(SHORTCUTS)}
        />
      )}
      {activeDialogs[NAVIGATION] && (
        <NavigationDialog
          onSelect={onSelectNavigation}
          onClose={() => onCloseDialog(NAVIGATION)}
        />
      )}
      {activeDialogs[LOGIN] && (
        <LoginDialog onClose={() => onCloseDialog(LOGIN)} />
      )}
    </>
  );
}
